import React, { Component } from 'react';
import { Toast, Checkbox, Modal } from 'antd-mobile';
import PropTypes from 'prop-types';
import {
  getProductDetails,
  addOrderByH5,
  getProtocolDetail,
  getAddressByOpenId,
} from '../../service/chat-service';
import tools from '../../utils/tools';
import ProgressComponent from '../../components/progress';
import SendVRCode from '../../components/sendVRCode';
import Address from './func-component';
import Protocol from '../protocol';
import styles from './styles.module.less';
import enterprise from './img/enterprise.png';
import rightImage from './img/right-jiantou.png';
import InvoiceModal from './invoice-modal';

const noop = () => { };

const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};

/**
 * 订单确认
 */
class orderConfirm extends Component {
  constructor(props) {
    super(props);
    document.title = '确认订单';

    const productId = tools.getQueryString('productId') || null;
    const shareUserId = tools.getQueryString('shareUserId') || null;
    const specificationId = tools.getQueryString('specificationId') || null;
    const liveId = tools.getQueryString('liveId') || null;
    const streamName = tools.getQueryString('streamName') || null;

    this.state = {
      loading: false,
      productDetail: {},
      phone: '',
      verifyCode: '',
      remark: '',
      productId,
      shareUserId,
      specificationId,
      streamName,
      liveId,
      buyNumber: 1,
      isRead: false,
      freePropertiesDataSource: [],
      protocolObj: {},
      modalKey: null,
      invoiceInfo: null, // 发票信息
      receivingInformation: {}, // 收货信息
      protocolModal: false, // 协议弹窗
      addressVisiable: false,
      selectedCombinationPrice: {}, // 所选组合价格
    };
  }

  componentDidMount() {
    this.loadData();
    this.loadProtocolDetail();
    this.loadAddress();
  }

  /**
   * 获取商品信息
   */
  loadData = async () => {
    const { productId, shareUserId, specificationId } = this.state;

    this.setState({ loading: true });
    try {
      const { code, data, message } = await getProductDetails(
        `?productId=${productId}&shareUserId=${shareUserId}`,
      );

      if (code !== 10000) throw message || '获取产品信息失败';

      const { freeProperties, priceType, specification } = data;
      const freePropertiesDataSource = freeProperties
        ? JSON.parse(freeProperties)
        : [];

      // 如果为组合价格
      let selectedCombinationPrice = {};
      if (priceType === 4) {
        selectedCombinationPrice = specification.find(
          (item) => item.id === specificationId,
        ) || {};
      }

      this.setState({
        productDetail: data,
        loading: false,
        freePropertiesDataSource,
        selectedCombinationPrice,
      });
    } catch (e) {
      Toast.show(e.message || e || '获取订单信息错误', 1.5);
      this.setState({ loading: false });
    }
  };

  /**
   * 获取协议
   */
  loadProtocolDetail = () => {
    const { productId } = this.state;

    getProtocolDetail(productId).then((res) => {
      const { code, data, message } = res;
      if (code !== 10000) return Toast.show(message || '查询购买协议失败', 1.5);
      this.setState({ protocolObj: data });
      return false;
    });
  };

  /**
   * 获取地址
   */
  loadAddress = () => {
    getAddressByOpenId().then((info) => {
      if (info) {
        const { consigneeAddress, phone, name } = info;
        const receivingInformation = {
          consigneeAddress,
          consigneeMobile: phone,
          consigneeName: name,
        };
        this.setState({ receivingInformation });
      }
    }).catch((e) => {
      Toast.show(e.message, 1.5);
    });
  };

  /**
   * 提交订单
   * @returns {Promise<void>}
   */
  confirmOrder = async () => {
    const { history } = this.props;
    const {
      productId,
      phone,
      verifyCode,
      remark,
      shareUserId,
      productDetail,
      isRead,
      freePropertiesDataSource,
      protocolObj,
      selectedCombinationPrice,
      streamName,
      liveId,
      invoiceInfo,
      receivingInformation,
      buyNumber,
    } = this.state;

    if (!phone || (phone && phone.length !== 11)) { return Toast.show('请检手机号输入', 1); }
    if (!verifyCode) return Toast.show('请检验证码输入');
    if (protocolObj.isEnableProtocol === 0 && !isRead) { return Toast.show('请阅读协议', 1); }
    // 自定义字段判断
    const freePropertiesIsRequire = freePropertiesDataSource.find(
      // eslint-disable-next-line react/destructuring-assignment
      (item) => item.notNull === 1 && !this.state[item.value],
    );
    if (freePropertiesIsRequire) { return Toast.show(`${freePropertiesIsRequire.name}不可为空`, 1); }

    this.setState({ loading: true });

    const option = {
      productId,
      shareUserId,
      verifyCode,
      accountMobile: phone,
      buyerRemark: remark && remark.trim(),
      source: 1,
      num: buyNumber,
      priceType: productDetail.priceType,
    };

    if (liveId) option.liveId = liveId;
    if (streamName) option.streamName = streamName;

    if (liveId || streamName) {
      option.liveUserId = localStorage.getItem('openId') || null;
      option.source = 2;
    }

    // 组合价格名字
    const { specificationId } = this.state;
    if (specificationId) {
      option.specificationName = selectedCombinationPrice.name;
      option.specificationId = specificationId;
    }

    // 发票
    if (productDetail.isInvoice === 1) {
      option.invoiceInfo = invoiceInfo;
    }

    // 收货地址
    if (productDetail.isOnlineDelivery === 1) {
      option.receivingInformation = receivingInformation;
    }

    // 自定义字段
    const freeProperties = {};
    freePropertiesDataSource.forEach((item) => {
      // eslint-disable-next-line react/destructuring-assignment
      freeProperties[item.value] = this.state[item.value] || '';
    });
    option.freeProperties = JSON.stringify(freeProperties);

    const openId = localStorage.getItem('openId') || null;

    option.openId = openId;

    try {
      const result = await addOrderByH5(option);
      const { code, data, message } = result;
      let orderId = null;
      if (data) orderId = data.orderId;
      const url = `/pay?orderId=${orderId}`;

      if (code === 10000) history.push(url);
      else Toast.show(message || '生成订单失败', 1.5);
    } catch (e) {
      Toast.show(e.message || '生成订单失败', 1.5);
    }

    this.setState({ loading: false });
    return false;
  };

  handleChange = (key, event) => {
    event.preventDefault();
    const { value } = event.target;
    this.setState({ [key]: value });
  };

  handleChangeAddress = (key) => (event) => {
    const { receivingInformation } = this.state;
    const { value } = event.target;
    this.setState({
      receivingInformation: {
        ...receivingInformation,
        [key]: value,
      },
    });
  };

  scrollPosition = () => {
    const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
    window.scrollTo(0, Math.max(scrollHeight - 1, 0));
  };

  showInvoiceModal = (modalKey) => () => {
    this.setState({ modalKey });
  };

  /**
   * 发票成功回调
   * @param invoiceInfo
   */
  handleSuccessAddInvoice = (invoiceInfo1) => {
    const invoiceInfo = invoiceInfo1;
    invoiceInfo.amount *= 100;
    this.setState({ invoiceInfo, modalKey: null });
  };

  handleHideModal = () => {
    this.setState({ modalKey: null });
  };

  /**
   * 返回自定义字段
   * @returns {null}
   */
  renderFreeProperties = () => {
    const { freePropertiesDataSource } = this.state;

    let freePropertiesElement = null;
    if (freePropertiesDataSource.length) {
      freePropertiesElement = freePropertiesDataSource.map((item) => {
        const { name, value, notNull } = item;
        // eslint-disable-next-line react/destructuring-assignment
        const itemValue = this.state[value];
        return (
          <div key={value} className={styles.itemStartContent}>
            <span className={styles.label}>{name}</span>
            <input
              type="text"
              value={itemValue}
              onBlur={this.scrollPosition}
              placeholder={Number(notNull) === 1 ? name : `选填，${name}`}
              onChange={this.handleChange.bind(null, value)}
            />
          </div>
        );
      });
    }

    return freePropertiesElement;
  };

  openProtocal = (key) => (e) => {
    e.preventDefault();
    this.setState({ [key]: true });
  };

  closeProtocal = (key) => () => {
    this.setState({ [key]: false });
  };

  handleLessNumber = () => {
    const { buyNumber } = this.state;
    const num = buyNumber - 1;

    if (num > 0) this.setState({ buyNumber: buyNumber - 1 });
  };

  handleAddNumber = () => {
    const { buyNumber } = this.state;
    this.setState({ buyNumber: buyNumber + 1 });
  };

  render() {
    const {
      phone,
      verifyCode,
      remark,
      loading,
      productDetail,
      isRead,
      receivingInformation,
      modalKey,
      buyNumber,
      selectedCombinationPrice,
      protocolObj,
      protocolModal,
      liveId,
    } = this.state;
    const { price, priceType } = productDetail;

    let goodsPrice = price;
    if (priceType === 4) {
      goodsPrice = selectedCombinationPrice.price;
    }

    return (
      <div className={styles.orderConfirmBox}>
        <ProgressComponent loading={loading} />
        <div className={styles.companyContent}>
          <div className={styles.companyBox}>
            <div className={styles.companyTitle}>
              <img src={enterprise} alt="公司" />
              <span className={styles.companyName}>
                {productDetail.companyName}
              </span>
            </div>
            <div className={styles.itemContentCompany}>
              <div className={styles.companyImage}>
                <img src={productDetail.productDetailsImg} alt=" " />
              </div>
              <div className={styles.companyText}>
                <p>{productDetail.name}</p>
                <span className={styles.number}>
                  {selectedCombinationPrice.name
                    ? `已选：${selectedCombinationPrice.name}`
                    : ''}
                </span>
                <div className={styles.item}>
                  <span className={styles.money}>
                    ¥
                    {' '}
                    {goodsPrice / 100 || '0.00'}
                  </span>
                  <span className={styles.number}>数量：x1</span>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.placeholderBox} />

          <div className={styles.itemContent}>
            <span className={styles.label}>购买数量</span>
            <div className={styles.modalBlock}>
              {buyNumber <= 1 || !selectedCombinationPrice.num ? (
                <span className={styles.disabledCountChange}>-</span>
              ) : (
                <span className={styles.less} onClick={this.handleLessNumber} role="button" tabIndex={0}>
                  -
                </span>
              )}
              <span className={styles.number}>{buyNumber}</span>
              {buyNumber >= selectedCombinationPrice.num
                || !selectedCombinationPrice.num ? (
                  <span className={styles.disabledCountChange}>+</span>
                ) : (
                  <span className={styles.add} onClick={this.handleAddNumber} role="button" tabIndex={0}>
                    +
                  </span>
                )}
            </div>
          </div>
          <div className={styles.placeholderBox} />

          <div className={styles.itemContentBottom}>
            <div className={styles.itemStartContent}>
              <div className={styles.left}>
                <span className={styles.label}>手机号</span>
                <input
                  // autoFocus
                  value={phone}
                  type="text"
                  maxLength={11}
                  onBlur={this.scrollPosition}
                  placeholder="请输入手机号"
                  onChange={this.handleChange.bind(null, 'phone')}
                />
              </div>
              <div className={styles.right}>
                <SendVRCode
                  type={liveId ? '2' : '1'}
                  phoneNumber={phone}
                />
              </div>
            </div>
            <div className={styles.itemStartContent}>
              <span className={styles.label}>验证码</span>

              <input
                type="text"
                maxLength={6}
                value={verifyCode}
                onBlur={this.scrollPosition}
                placeholder="请输入验证码"
                onChange={this.handleChange.bind(null, 'verifyCode')}
              />
            </div>
            <div className={styles.itemStartContent}>
              <span className={styles.label}>买家留言</span>
              <input
                value={remark}
                type="text"
                onBlur={this.scrollPosition}
                placeholder="选填，请和商家协商一致"
                onChange={this.handleChange.bind(null, 'remark')}
              />
            </div>
            {productDetail.isOnlineDelivery === 1 && (
              <Address
                phone={phone}
                receivingInformation={receivingInformation}
                handleChangeAddress={this.handleChangeAddress}
                scrollPosition={this.scrollPosition}
              />
            )}

            {/* <div className={styles.placeholderBox} /> */}
            {productDetail.isInvoice === 1 && (
              <div className={styles.itemStartContent}>
                <div>
                  <span className={styles.label}>开具发票</span>
                  <p className={styles.notice}>
                    该商品支持开具发票，如需发票请完善相关信息
                  </p>
                </div>
                <div
                  className={styles.noticeRight}
                  onClick={this.showInvoiceModal('INVOICE')}
                  role="button"
                  tabIndex={0}
                >
                  <img src={rightImage} alt="rightImage" />
                </div>
                <InvoiceModal
                  visible={modalKey === 'INVOICE'}
                  onSuccess={this.handleSuccessAddInvoice}
                  onCancel={this.handleHideModal}
                  amount={(goodsPrice * buyNumber) / 100 || '0.00'}
                />
              </div>
            )}

            {this.renderFreeProperties()}

            {protocolObj.isEnableProtocol === 0 && (
              <Checkbox.AgreeItem
                style={{ paddingTop: 15 }}
                value={isRead}
                onChange={(e) => {
                  this.setState({ isRead: e.target.checked });
                }}
              >
                <div className={styles.protocol}>
                  已阅读并同意&nbsp;
                  <span
                    onClick={this.openProtocal('protocolModal')}
                    style={{ color: '#4885FF' }}
                    role="button"
                    tabIndex={0}
                  >
                    {protocolObj.protocolName}
                  </span>
                  <Modal
                    wrapClassName={{ height: '40%' }}
                    className={styles.protocolModel}
                    visible={protocolModal}
                    transparent
                    closable
                    title={protocolObj.protocolName}
                    onClose={this.closeProtocal('protocolModal')}
                    maskClosable={false}
                  >
                    <Protocol />
                  </Modal>
                </div>
              </Checkbox.AgreeItem>
            )}
          </div>
        </div>
        <div className={styles.footer}>
          <div className={styles.footerPrice}>
            <span>合计：</span>
            <span className={styles.money}>
              ¥
              {(goodsPrice * buyNumber) / 100 || '0.00'}
            </span>
          </div>
          <div
            className={styles.confirmOrder}
            onClick={productDetail.isRelease === 0 ? this.confirmOrder : noop}
            role="button"
            tabIndex={0}
          >
            {productDetail.isRelease === 0 ? '提交订单' : '产品已下线'}
          </div>
        </div>
      </div>
    );
  }
}

orderConfirm.propTypes = propTypes;

export default orderConfirm;
